import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { listActors, createActor, updateActor, deleteActor, reorderActors } from './api';
import type { CreateActorRequest, UpdateActorRequest } from './types';

const ACTORS_QUERY_KEY = ['admin', 'actors'];

/**
 * AI俳優一覧を取得するフック
 */
export function useActors() {
  return useQuery({
    queryKey: ACTORS_QUERY_KEY,
    queryFn: listActors,
  });
}

/**
 * AI俳優を作成するフック
 */
export function useCreateActor() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: CreateActorRequest) => createActor(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ACTORS_QUERY_KEY });
    },
  });
}

/**
 * AI俳優を更新するフック
 */
export function useUpdateActor() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ actorId, request }: { actorId: string; request: UpdateActorRequest }) =>
      updateActor(actorId, request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ACTORS_QUERY_KEY });
    },
  });
}

/**
 * AI俳優を削除するフック
 */
export function useDeleteActor() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (actorId: string) => deleteActor(actorId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ACTORS_QUERY_KEY });
    },
  });
}

/**
 * AI俳優の表示順を更新するフック
 */
export function useReorderActors() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (order: { id: string; display_order: number }[]) => reorderActors(order),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ACTORS_QUERY_KEY });
    },
  });
}
